import React from 'react';

import { Box } from '~/eds/src/components/Box/Box';
import { Layout } from '~/eds/src/components/Layout/Layout';

interface Props {
  children: React.ReactNode;
  sidebar: React.ReactNode;
}

const AppLayout = ({ children, sidebar }: Props) => {
  return (
    <Layout flex="1 1 0" h="100%" minH={0} minW={0}>
      <Box flex="auto" minW={0}>
        {children}
      </Box>
      {sidebar && <Box flex="none">{sidebar}</Box>}
    </Layout>
  );
};

export default AppLayout;
